import React, { Component } from 'react';
import Helmet from 'react-helmet';
import SchedulerightFeatures from './features/SchedulerightFeatures';
import { Container, Row, Col } from 'reactstrap';
import Link from 'gatsby-link';
import ActionLink from '../../../components/actionlink/ActionLink';

import './index.scss'
var version = '1.0.2 beta2';

class SchedulerightPage extends Component {
    render() {
        return (
            <div className='scheduleright-container'>
                <Helmet title={`Datasert - Scheduleright`} />

                <div className="main">
                    <Container>
                        <Row>
                            <Col className='main-left'>
                                <h2>Scheduleright</h2>
                                <h3>Enjoy the Enterprise Grade Job Scheduling Natively in Salesforce</h3>
                                <p>Current Version: {version}</p>
                                <p>Read <Link to='/products/scheduleright/docs#setup'>Docs</Link> or <Link to='/products/scheduleright/faq'>FAQ</Link></p>
                                <p><a href="/company/contact">Contact Us</a> to try this out</p>
                            </Col>
                            <Col><img className='banner-image' src={require('./features/scheduler-jobs-listview.png')} /></Col>
                        </Row>
                    </Container>
                </div>

                <div className="features">
                    <h2 className='title'>Top Features of Scheduleright</h2>
                    <a name="features"></a>
                    <SchedulerightFeatures />
                </div>
            </div>
        );
    }
}

export default SchedulerightPage;


// WEBPACK FOOTER //
// ./src/pages/products/scheduleright/index.jsx